<div class="new-vs-returning-card" [style.background]="data.gradient">
  <div class="card-content">
    <div class="card-main-content">
      <div class="title-container">
        <h3 class="card-title">
          {{ data.title }}
          <div
            class="info-icon"
            *ngIf="data.tooltip"
            [matTooltip]="data.tooltip"
            tabindex="0"
            matTooltipPosition="above"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 0C3.134 0 0 3.134 0 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 12.833c-3.225 0-5.833-2.608-5.833-5.833S3.775 1.167 7 1.167 12.833 3.775 12.833 7 10.225 12.833 7 12.833z"
                fill="currentColor"
              />
              <path
                d="M7 3.5c-.483 0-.875.392-.875.875S6.517 5.25 7 5.25s.875-.392.875-.875S7.483 3.5 7 3.5zM7 6.125c-.483 0-.875.392-.875.875v2.625c0 .483.392.875.875.875s.875-.392.875-.875V7c0-.483-.392-.875-.875-.875z"
                fill="currentColor"
              />
            </svg>
          </div>
        </h3>
      </div>

      <div class="customers-container">
        <div class="customer-row">
          <div class="customer-count">
            <span class="count-value">{{ data.newCustomers.count }}</span>
          </div>
          <div class="customer-large-count">
            <span class="large-count-value">{{ data.returningCustomers.count }}</span>
          </div>
        </div>

        <div class="percentages-row">
          <div class="percentage-section">
            <div class="percentage-badge">
              <span class="percentage">{{ data.newCustomers.percentage }}%</span>
            </div>
            <span class="customer-type">New</span>
          </div>

          <div class="percentage-section returning">
            <div class="percentage-badge">
              <span class="percentage">{{ data.returningCustomers.percentage }}%</span>
            </div>
            <span class="customer-type">Returning</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
